<template>
  <div
    class="container-fluid"
    style="
      min-height: 100vh;
      height: auto;
      padding-bottom: 50px;
      background-color: #fed8b1;
    "
  >
    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-9 text-center mt-5" style="text-wrap: balance">
        <p class="main-title">
          {{ currentLanguage === "EN" ? "# Are you looking for some encouragement?" : "# 您正在尋找一些鼓勵嗎？" }}
        </p>
        <p class="second-title">
          {{ currentLanguage === "EN" ? "Whatever difficulties or challenges you are facing, we are here to provide the encouragement you need." : "無論您遇到什麼困難或挑戰，我們都在這裡提供您需要的心靈雞湯。" }}
        </p>
      </div>
    </div>

    <div class="header-controls">
      <div class="social-links">
        <a @click="toggleLanguage" style="cursor: pointer; color: #c17c6e">
          <font-awesome-icon :icon="['fas', 'language']" size="lg" />
        </a>
        <a href="https://instagram.com" target="_blank" style="color: #c17c6e">
          <font-awesome-icon :icon="['fab', 'instagram']" size="lg" />
        </a>
        <a href="https://github.com" target="_blank" style="color: #c17c6e">
          <font-awesome-icon :icon="['fab', 'github']" size="lg" />
        </a>
      </div>
    </div>

    <div class="row justify-content-center mt-4">
      <div class="col-sm-12 col-md-6 text-center">
        <div class="card-container">
          <img 
            src="@/image/grow.png"
            alt="Soul Soup" 
            class="grow-img"
            @click="onGenerateSoulSoup"
            style="cursor: pointer;"
          />
          
          <button class="rounded-button" :disabled="isLoading" @click="onGenerateSoulSoup">
            {{ currentLanguage === "EN" ? "Nourish Your Soul" : "讓心靈獲得滋養" }}
          </button>
          
          <div v-if="isLoading" class="loading-spinner mt-3">
            <span>{{ currentLanguage === "EN" ? "Loading..." : "載入中..." }}</span>
          </div>
          
          <div v-if="message" class="result-box mt-3">
            <p>{{ message }}</p>
          </div>
          
          <div class="tags-container mt-4">
            <div class="tags-wrapper">
              <span 
                v-for="tag in tags[currentLanguage === 'EN' ? 'EN' : 'CH']" 
                :key="tag"
                :class="['tag-item', { 'selected': selectedTag === tag }]"
                @click="selectedTag = tag"
              >
                {{ tag }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-section">
      <div class="footer-content">
        <p>{{ currentLanguage === "EN" ? "Wishing you a wonderful day" : "祝您有美好的一天" }}</p>
        <p>Site by Jacky Lee © 2024</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faGithub } from "@fortawesome/free-brands-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faInstagram, faGithub, faLanguage);

// Edge Function URL - 不需要 API Key，因為這是公開 API
const SUPABASE_FUNCTION_URL = "https://bxqznxcrwuyvnpsvmbob.supabase.co/functions/v1/generate-soul-soup";

export default {
  components: { FontAwesomeIcon },
  data() {
    return {
      currentLanguage: "EN",
      selectedTag: null,
      message: "",
      isLoading: false,
      tags: {
        EN: ["😣 Stress", "🥰 Love", "🏢 Work", "📖 Study", "👨‍👩‍👦 Family", "🚑 Health", "💰 Finance", "✍ Self-Improvement", "🤗 Social Relationships", "🌅 Leisure"],
        CH: ["😣 壓力", "🥰 愛情", "🏢 工作", "📖 學業", "👨‍👩‍👦 家庭", "🚑 健康", "💰 財務", "✍ 自我提升", "🤗 人際關係", "🌅 休閒"]
      }
    };
  },
  created() {
    this.checkUrlLanguage();
    this.setDefaultTag();
  },
  methods: {
    checkUrlLanguage() {
      const urlParams = new URLSearchParams(window.location.search);
      const lang = urlParams.get("lan");
      if (lang) this.currentLanguage = lang.toUpperCase() === "CH" ? "CH" : "EN";
    },
    setDefaultTag() {
      this.selectedTag = this.currentLanguage === "EN" ? "😣 Stress" : "😣 壓力";
    },
    toggleLanguage() {
      this.currentLanguage = this.currentLanguage === "EN" ? "CH" : "EN";
      this.setDefaultTag();
    },
    async onGenerateSoulSoup() {
      if (this.isLoading) return;
      
      this.isLoading = true;
      this.message = "";

      try {
        // 1. 執行 reCAPTCHA 驗證
        const token = await this.$recaptcha("generate_soul_soup");

        // 2. 轉換語言代碼 (CH -> ZH)
        const apiLang = this.currentLanguage === "CH" ? "ZH" : "EN";

        // 3. 呼叫 Edge Function - 不需要 Authorization header
        const response = await axios.post(
          SUPABASE_FUNCTION_URL,
          {
            soulTagName: this.selectedTag,
            language: apiLang,
            recaptchaToken: token,
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        // 4. 解析回應
        if (response.data?.choices?.[0]?.message?.content) {
          this.message = response.data.choices[0].message.content;
        } else if (response.data?.error) {
          throw new Error(response.data.error);
        } else {
          throw new Error("Invalid response format");
        }

      } catch (error) {
        console.error("API Error:", error);
        
        // 處理不同類型的錯誤
        if (error.response?.data?.error) {
          this.message = error.response.data.error;
        } else if (error.response?.status === 429) {
          this.message = this.currentLanguage === "EN" 
            ? "Daily limit reached. Please try again tomorrow." 
            : "已達今日公開使用上限，請明天再試。";
        } else {
          this.message = this.currentLanguage === "EN" 
            ? "Network Error. Please try again later or contact Jacky Lee." 
            : "網路異常，請稍後再試或洽詢製作者 Jacky Lee。";
        }
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.main-title {
  font-size: 2rem;
  font-weight: bold;
  color: #5a3d31;
}

.second-title {
  font-size: 1.1rem;
  color: #7a5d51;
}

.header-controls {
  position: absolute;
  top: 20px;
  right: 20px;
}

.social-links {
  display: flex;
  gap: 15px;
}

.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.rounded-button {
  background-color: #7dcfb6;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 25px;
  width: 80%;
  max-width: 300px;
  transition: 0.3s;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 15px;
}

.rounded-button:hover:not(:disabled) {
  background-color: #5ba592;
}

.rounded-button:disabled {
  background-color: #b0b0b0;
  cursor: not-allowed;
}

.result-box {
  background-color: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  line-height: 1.6;
  max-width: 400px;
  width: 100%;
}

.grow-img {
  max-width: 200px;
  transition: transform 0.3s;
}

.grow-img:active {
  transform: scale(0.9);
}

.tags-container {
  width: 100%;
  max-width: 500px;
}

.tags-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
}

.tag-item {
  background-color: #fff;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
}

.tag-item:hover {
  background-color: #f0e6dc;
}

.tag-item.selected {
  background-color: #7dcfb6;
  color: white;
  border-color: #5ba592;
}

.loading-spinner {
  color: #7a5d51;
}

.footer-section {
  margin-top: 50px;
  text-align: center;
}

.footer-content {
  color: #7a5d51;
  font-size: 0.9rem;
}
</style>
